import { Grid2 as Grid, Typography, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Link, styled } from '@mui/material';
import ShortFiler from '../../../../../types/filers/shortFiler';


interface Props {
    filers?:ShortFiler[]
    type: string;
}


const RecentlyOrganizedTable = (props: Props): JSX.Element => {

    return (
        <>
            <TableContainer>
                <Table aria-label="recently organized table" size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={600}>
                                     CPF ID
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={600}>
                                     Name/Address
                                </Typography>
                            </TableCell>
                            {
                                props.type==="C" &&
                                <TableCell>
                                    <Typography variant={'subtitle1'} fontWeight={600}>
                                     Office/District
                                     </Typography>
                                </TableCell>
                            }
                            {
                                props.type==="C" &&
                                <TableCell>
                                    <Typography variant={'subtitle1'} fontWeight={600}>
                                     Party
                                     </Typography>
                                </TableCell>
                            }
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={600}>
                                     Organized
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={600}>
                                     Form
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.filers?.map((filer) => (
                        <TableRow
                            key={filer.cpfId}
                            sx={{
                                '&:last-child td, &:last-child th': { border: 0 },
                                '&:nth-of-type(odd)': {
                                    backgroundColor: '#fafafa',
                                  },
                            }}
                        >
                            <TableCell scope="row">
                                <Typography variant={'subtitle1'} component={Link} href={`/filers?q=${filer.cpfId}`} underline="hover">
                                    {filer.cpfId}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle1'} fontWeight={550}>
                                    {filer.fullNameReverse}
                                </Typography>
                                <Typography color={'text.secondary'} component={'i'} variant={'subtitle2'}>
                                    {filer.fullAddress}
                                </Typography>
                            </TableCell>
                            {
                                props.type==="C" &&
                                <TableCell>
                                    <Typography variant={'subtitle1'}>
                                        {filer.officeSoughtDescription}
                                    </Typography>
                                </TableCell>
                            }
                            {
                                props.type==="C" &&
                                <TableCell>
                                    <Typography variant={'subtitle1'} fontWeight={600}>
                                        {filer.partyAffiliation}
                                     </Typography>
                                </TableCell>
                            }
                            <TableCell>
                                <Typography variant={'subtitle1'}>
                                    {filer.organizationDate}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                {
                                    filer.organizationFormFileName &&
                                    <Typography variant={'subtitle1'} component={Link} href={filer.organizationStatementBlobUrl} target="_blank" underline="hover">
                                        Statement Link
                                    </Typography>
                                }
                            </TableCell>
                        </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default RecentlyOrganizedTable;